import { FC, PropsWithChildren } from "react";
import { HotspotItemContextProvider } from "../../providers/HotspotItemProvider";

export const HotspotItem: FC<PropsWithChildren> = ({ children }) => {
	return <HotspotItemContextProvider>{children}</HotspotItemContextProvider>;
};
